import { UploadsAPI } from '../../../api/spidermap/UploadsAPI';

export class UploadsCommand {
    uploadStopImage(data, file, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", file);

        const apiResult = UploadsAPI.uploadStopImage(data.id, dataToSend);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback("Imagem carregada com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/spidermap/commands/UploadsCommand.js